module.exports = __webpack_public_path__ + "static/media/appstore.0669a767.svg";